import { render, staticRenderFns } from "./Trustpilot.vue?vue&type=template&id=1d7de145&scoped=true"
import script from "./Trustpilot.vue?vue&type=script&lang=js"
export * from "./Trustpilot.vue?vue&type=script&lang=js"
import style0 from "./Trustpilot.vue?vue&type=style&index=0&id=1d7de145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7de145",
  null
  
)

export default component.exports